import React, { useState } from "react";
import RaytebModal from "../Modal/RaytebModal";
import LoadingFit from "../Loading/LoadingFit";

const Photo: React.FC<FileInterface> = React.memo(({
    fileName,
    fileAddress,
    isLoading
}) => {
    const [showImage, setShowImage] = useState<boolean>(false);

    return <> <div className="max-h-[300px]  p-3 bg-disable rounded-2xl cursor-pointer w-full relative overflow-hidden" onClick={() => setShowImage(true)}>
        <LoadingFit isLoading={isLoading ?? false} />
        <span className="text-xs">{fileName.split('.')[0].shortText(50)}</span>
        <div className="w-full h-full flex justify-center items-center overflow-auto ">
            <img className="object-cover max-w-[300px] " src={fileAddress} />
        </div>
    </div>
        <RaytebModal className={'fixed left-0 top-0 w-full h-full'} isOpen={showImage} hideModal={() => setShowImage(false)} onRequestClose={() => setShowImage(false)}>
            <div className="w-full h-full p-2 ">
                <img className="object-cover" src={fileAddress} />
            </div>
        </RaytebModal>
    </>
})

export default Photo;